import { render } from "./StudentBasicData.vue?vue&type=template&id=652d362a&scoped=true"
import script from "./StudentBasicData.vue?vue&type=script&lang=js"
export * from "./StudentBasicData.vue?vue&type=script&lang=js"

import "./StudentBasicData.vue?vue&type=style&index=0&id=652d362a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652d362a"]])

export default __exports__